import { render, staticRenderFns } from "./Sadmin.vue?vue&type=template&id=960c99fa&scoped=true&"
import script from "./Sadmin.vue?vue&type=script&lang=js&"
export * from "./Sadmin.vue?vue&type=script&lang=js&"
import style0 from "./Sadmin.vue?vue&type=style&index=0&id=960c99fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960c99fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('960c99fa')) {
      api.createRecord('960c99fa', component.options)
    } else {
      api.reload('960c99fa', component.options)
    }
    module.hot.accept("./Sadmin.vue?vue&type=template&id=960c99fa&scoped=true&", function () {
      api.rerender('960c99fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/Sadmin.vue"
export default component.exports